/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-08 14:56:28
 * @LastEditTime: 2019-08-11 07:56:03
 * @LastEditors: Please set LastEditors
 */
import Home from "@/views/prd/Home";


//inventory
import AdjustList from "@/views/prd/inventoryMgt/adjustInventory/AdjustList";
import OutInList from "@/views/prd/inventoryMgt/outInInventory/OutInList";
import RawMaterialList from "@/views/prd/inventoryMgt/rawMaterial/RawMaterialList";
// import RawMaterialEdit from "@/views/prd/inventoryMgt/rawMaterial/RawMaterialEdit";
import FormulaPlanList from "@/views/prd/inventoryMgt/formulaPlan/FormulaPlanList";
import FormulaPlanEdit from"@/views/prd/inventoryMgt/formulaPlan/FormulaPlanEdit";
import FormulaPlanDetailsEdit from"@/views/prd/inventoryMgt/formulaPlan/FormulaPlanDetailsEdit";

import OutInEdit from "@/views/prd/inventoryMgt/outInInventory/OutInEdit";

//prd plan
import DowntimePlanList from "@/views/prd/productionPlan/DowntimePlanList";
import DowntimePlanEdit from "@/views/prd/productionPlan/DowntimePlanEdit";

import MonthPlanList from "@/views/prd/productionPlan/MonthPlanList";
import MonthPlanEdit from "@/views/prd/productionPlan/MonthPlanEdit";

import MatRequireMonthPlanList from "@/views/prd/productionPlan/MatRequireMonthPlanList";
import MatRequireMonthPlanEdit from "@/views/prd/productionPlan/MatRequireMonthPlanEdit";

import ShiftPlanList from "@/views/prd/productionPlan/ShiftPlanList";
import ShiftPlanEdit from "@/views/prd/productionPlan/ShiftPlanEdit";

//prd result
import PelletizingEnergyCostList from "@/views/prd/productionExecution/pelletizing/pelletizingEnergyCost/PelletizingEnergyCostList";
import PelletizingEquipParaList from "@/views/prd/productionExecution/pelletizing/pelletizingEquipPara/PelletizingEquipParaList";
import PelletizingMaterialCostList from "@/views/prd/productionExecution/pelletizing/pelletizingMaterialCost/PelletizingMaterialCostList";
import PelletizingProductInfoList from "@/views/prd/productionExecution/pelletizing/pelletizingProductInfo/PelletizingProductInfoList";
import PelletizingProductionResultList from "@/views/prd/productionExecution/pelletizing/pelletizingProductionResult/PelletizingProductionResultList";
import PelletizingProductQualityList from "@/views/prd/productionExecution/pelletizing/pelletizingProductQuality/PelletizingProductQualityList";
import PelletizingProductionQualityList from "@/views/prd/productionExecution/pelletizing/pelletizingProductQuality/PelletizingProductionQualityList";

import SmeltingProductionResultList from "@/views/prd/productionExecution/smelting/smeltingProductionResult/SmeltingProductionResultList";
import SmeltingMaterialCostList from "@/views/prd/productionExecution/smelting/smeltingMaterialCost/SmeltingMaterialCostList";
import SmeltingEnergyCostList from "@/views/prd/productionExecution/smelting/smeltingEnergyCost/SmeltingEnergyCostList";
import SmeltingProductInfoList from "@/views/prd/productionExecution/smelting/smeltingProductInfo/SmeltingProductInfoList";
import SmeltingProductQualityList from "@/views/prd/productionExecution/smelting/smeltingProductQuality/SmeltingProductQualityList";
import SmeltingEquipParaList from "@/views/prd/productionExecution/smelting/smeltingEquipPara/SmeltingEquipParaList";
import SmeltingMaterialPercentRecordList from "@/views/prd/productionExecution/smelting/smeltingMaterialPercentRecord/SmeltingMaterialPercentRecordList";
import SmeltingMaterialPercentRecordEidt from "@/views/prd/productionExecution/smelting/smeltingMaterialPercentRecord/SmeltingMaterialPercentRecordEdit";
import SmeltingProductionQualityList from "@/views/prd/productionExecution/smelting/smeltingProductQuality/SmeltingProductionQualityList";

//report
import DayEnergyCostList from "@/views/prd/productionReport/dayReport/dayEnergyCost/DayEnergyCostList";
import DayEquipParaList from "@/views/prd/productionReport/dayReport/dayEquipPara/DayEquipParaList";
import DayMaterialCostList from "@/views/prd/productionReport/dayReport/dayMaterialCost/DayMaterialCostList";
import DayPelletizingProductInfoList from "@/views/prd/productionReport/dayReport/dayPelletizingProductInfo/DayPelletizingProductInfoList";
import DayPelletizingProductQualityList from "@/views/prd/productionReport/dayReport/dayPelletizingProductQuality/DayPelletizingProductQualityList";
import DayPelletizingProductionQualityList from "@/views/prd/productionReport/dayReport/dayPelletizingProductQuality/DayPelletizingProductionQualityList";
import DaySmeltingProductInfoList from "@/views/prd/productionReport/dayReport/daySmeltingProductInfo/DaySmeltingProductInfoList";
import DaySmeltingProductQualityList from "@/views/prd/productionReport/dayReport/daySmeltingProductQuality/DaySmeltingProductQualityList";
import DaySmeltingProductionQualityList from "@/views/prd/productionReport/dayReport/daySmeltingProductQuality/DaySmeltingProductionQualityList";
import MonthEnergyCostList from "@/views/prd/productionReport/monthReport/monthEnergyCost/MonthEnergyCostList";
import MonthEquipParaList from "@/views/prd/productionReport/monthReport/monthEquipPara/MonthEquipParaList";
import MonthMaterialCostList from "@/views/prd/productionReport/monthReport/monthMaterialCost/MonthMaterialCostList";
import MonthPelletizingProductInfoList from "@/views/prd/productionReport/monthReport/monthPelletizingProductInfo/MonthPelletizingProductInfoList";
import MonthPelletizingProductQualityList from "@/views/prd/productionReport/monthReport/monthPelletizingProductQuality/MonthPelletizingProductQualityList";
import MonthPelletizingProductionQualityList from "@/views/prd/productionReport/monthReport/monthPelletizingProductQuality/MonthPelletizingProductionQualityList";
import MonthSmeltingProductInfoList from "@/views/prd/productionReport/monthReport/monthSmeltingProductInfo/MonthSmeltingProductInfoList";
import MonthSmeltingProductQualityList from "@/views/prd/productionReport/monthReport/monthSmeltingProductQuality/MonthSmeltingProductQualityList";
import MonthSmeltingProductionQualityList from "@/views/prd/productionReport/monthReport/monthSmeltingProductQuality/MonthSmeltingProductionQualityList";
import FurnaceTemperatureList from "@/views/prd/dailyReportMgt/FurnaceTemperatureList";
import FurnaceTemperatureEdit from "@/views/prd/dailyReportMgt/FurnaceTemperatureEdit";

//quality
import QualitySpecificationList from "@/views/prd/qualityMgt/QualitySpecificationList";
import QualitySpecificationEdit from "@/views/prd/qualityMgt/QualitySpecificationEdit";

import QualityItemList from "@/views/prd/qualityMgt/qualityItemConfig/QualityItemList";
import QualityItemEdit from "@/views/prd/qualityMgt/qualityItemConfig/QualityItemEdit";
import QualityItemAdd from "@/views/prd/qualityMgt/qualityItemConfig/QualityItemAdd";
import QualityItemDetailsList from "@/views/prd/qualityMgt/qualityItemConfig/QualityItemDetailsList";
import QualityItemDetailsEdit from "@/views/prd/qualityMgt/qualityItemConfig/QualityItemDetailsEdit";

import SelfTestPelletizingList from "@/views/prd/qualityMgt/selfTest/SelfTestPelletizingList";
import SelfTestPelletizingEdit from "@/views/prd/qualityMgt/selfTest/SelfTestPelletizingEdit";
import SelfTestPelletizingGriList from "@/views/prd/qualityMgt/selfTest/SelfTestPelletizingGriList";
import SelfTestPelletizingGriEdit from "@/views/prd/qualityMgt/selfTest/SelfTestPelletizingGriEdit";
import SelfTestPelletizingPelList from "@/views/prd/qualityMgt/selfTest/SelfTestPelletizingPelList";
import SelfTestPelletizingPelEdit from "@/views/prd/qualityMgt/selfTest/SelfTestPelletizingPelEdit";
import SelfTestPelletizingCalList from "@/views/prd/qualityMgt/selfTest/SelfTestPelletizingCalList";
import SelfTestPelletizingCalEdit from "@/views/prd/qualityMgt/selfTest/SelfTestPelletizingCalEdit";
// import SelftestPelletizingReportList from "@/views/prd/qualityMgt/selfTest/SelftestPelletizingReportList";

import QualityPlanList from "@/views/prd/qualityMgt/pelletizing/QualityPlanList";
import QualitySamplePlanList from "@/views/prd/qualityMgt/pelletizing/QualitySamplePlanList";
import QualitySamplePlanEdit from "@/views/prd/qualityMgt/pelletizing/QualitySamplePlanEdit";
import QualityDataList from "@/views/prd/qualityMgt/pelletizing/QualityDataList";
import QualitySampleReceiveList from "@/views/prd/qualityMgt/pelletizing/QualitySampleReceiveList";
import QualityCheckList from "@/views/prd/qualityMgt/pelletizing/QualityCheckList";
import QualityReviewList from "@/views/prd/qualityMgt/pelletizing/QualityReviewList";

import QualityResultList from "@/views/prd/qualityMgt/pelletizing/QualityResultList";
import QualityDataCheckList from "@/views/prd/qualityMgt/pelletizing/QualityDataCheckList";
import QualityResultDisplay from "@/views/prd/qualityMgt/pelletizing/QualityResultDisplay";

import SlagMeltingPointList from "@/views/prd/qualityMgt/pelletizing/SlagMeltingPointList";

//prd record
import CeramicFilterParaRecordList from "@/views/prd/productionExecution/pelletizing/ceramicFilterParaRecord/CeramicFilterParaRecord";
import CeramicFilterParaEdit from "@/views/prd/productionExecution/pelletizing/ceramicFilterParaRecord/CeramicFilterParaEdit";
import SmeltingPreheatingKilnParaRecord from "@/views/prd/productionExecution/smelting/smeltingPreheatingKilnPara/smeltingPreheatingKilnParaRecord";
import SmeltingPreheatingKilnParaEdit from "@/views/prd/productionExecution/smelting/smeltingPreheatingKilnPara/smeltingPreheatingKilnParaEdit";
import SmeltingFurnaceMeasureList from "@/views/prd/productionExecution/smelting/smeltingFurnaceMeasure/smeltingFurnaceMeasureList";
import SmeltingFurnaceMeasureEdit from "@/views/prd/productionExecution/smelting/smeltingFurnaceMeasure/SmeltingFurnaceMeasureEdit";
import CoolingWaterParaList from "@/views/prd/productionExecution/smelting/smeltingFurnaceMeasure/CoolingWaterParaList";
import CoolingWaterParaEdit from "@/views/prd/productionExecution/smelting/smeltingFurnaceMeasure/CoolingWaterParaEdit";
import ElectrodePasteParaList from "@/views/prd/productionExecution/smelting/smeltingFurnaceMeasure/ElectrodePasteParaList";
import ElectrodePasteParaEdit from "@/views/prd/productionExecution/smelting/smeltingFurnaceMeasure/ElectrodePasteParaEdit";
import ThickenerPumpParaList from "@/views/prd/productionExecution/smelting/smeltingFurnaceMeasure/ThickenerPumpParaList";
import ThickenerPumpParaEdit from "@/views/prd/productionExecution/smelting/smeltingFurnaceMeasure/ThickenerPumpParaEdit";
import SmeltingPreheatingKilnStopList from "@/views/prd/productionExecution/smelting/smeltingPreheatingKilnPara/smeltingPreheatingKilnStopList";
import SmeltingPreheatingKilnStopEdit from "@/views/prd/productionExecution/smelting/smeltingPreheatingKilnPara/smeltingPreheatingKilnStopEdit";
import PressureDropWeightChangeList from "@/views/prd/productionExecution/smelting/smeltingElectrodeManagement/PressureDropWeightChangeList";
import PressureDropWeightChangeEdit from "@/views/prd/productionExecution/smelting/smeltingElectrodeManagement/PressureDropWeightChangeEdit";
import ReleasedElectrodeParaList from "@/views/prd/productionExecution/smelting/smeltingElectrodeManagement/ReleasedElectrodeParaList";
import ReleasedElectrodeParaEdit from "@/views/prd/productionExecution/smelting/smeltingElectrodeManagement/ReleasedElectrodeParaEdit";
import ElectrodeDischargePlanList from "@/views/prd/productionExecution/smelting/smeltingElectrodeManagement/ElectrodeDischargePlanList";
import ElectrodeDischargePlanEdit from "@/views/prd/productionExecution/smelting/smeltingElectrodeManagement/ElectrodeDischargePlanEdit";
import GasCabinetParaList from "@/views/prd/productionExecution/smelting/smeltingGasCabinetMgt/GasCabinetParaList";
import GasCabinetParaEdit from "@/views/prd/productionExecution/smelting/smeltingGasCabinetMgt/GasCabinetParaEdit";
import GasFlowParaList from "@/views/prd/productionExecution/smelting/smeltingGasCabinetMgt/GasFlowParaList";
import GasFlowParaEdit from "@/views/prd/productionExecution/smelting/smeltingGasCabinetMgt/GasFlowParaEdit";
import SubstationOperationParaList from "@/views/prd/productionExecution/smelting/smeltingSubstationMgt/SubstationOperationParaList";
import SubstationOperationParaEdit from "@/views/prd/productionExecution/smelting/smeltingSubstationMgt/SubstationOperationParaEdit";
import FurnacePowerFailureList from "@/views/prd/productionExecution/smelting/smeltingSubstationMgt/FurnacePowerFailureList";
import FurnacePowerFailureEdit from "@/views/prd/productionExecution/smelting/smeltingSubstationMgt/FurnacePowerFailureEdit";
import SlagIronParaList from "@/views/prd/productionExecution/smelting/smeltingSlagIronMgt/SlagIronParaList";
import SlagIronParaEdit from "@/views/prd/productionExecution/smelting/smeltingSlagIronMgt/SlagIronParaEdit";
import ElectrodeResistanceList from "@/views/prd/productionExecution/smelting/smeltingSlagIronMgt/ElectrodeResistanceList";
import ElectrodeResistanceEdit from "@/views/prd/productionExecution/smelting/smeltingSlagIronMgt/ElectrodeResistanceEdit";
import DrillDepthList from "@/views/prd/productionExecution/smelting/smeltingSlagIronMgt/DrillDepthList";
import DrillDepthEdit from "@/views/prd/productionExecution/smelting/smeltingSlagIronMgt/DrillDepthEdit";
import PelletFeedingList from "@/views/prd/productionExecution/smelting/smeltingSlagIronMgt/PelletFeedingList";
import PelletFeedingEdit from "@/views/prd/productionExecution/smelting/smeltingSlagIronMgt/PelletFeedingEdit";

//luanwf ShiftHandOver
import ShiftHandOverList from "@/views/prd/shiftHandOver/ShiftHandOverList";
import ShiftHandOverEdit from "@/views/prd/shiftHandOver/ShiftHandOverEdit";
import ProductionInformList from "@/views/prd/productionInform/ProductionInformList"
import ProductionInformEdit from "@/views/prd/productionInform/ProductionInformEdit"
import ProductionInformDisplay from "@/views/prd/productionInform/ProductionInformDisplay"
export default [
    {
        path: "/prd",
        name: "home-prd",
        component: Home
    },
    //inventory
    {
        path: "/inventory/adjust",
        name: "adjustList",
        component: AdjustList
    },
    {
        path: "/inventory/outInInventory",
        name: "outInList",
        component: OutInList
    },
    {
        path: "/inventory/outInInventory/edit",
        name: "outInEdit",
        component: OutInEdit
    },
    {
        path: "/inventory/rawMaterial",
        name: "rawMaterialList",
        component: RawMaterialList
    },
    // {
    //     path: "/inventory/rawMaterial/Edit",
    //     name: "rawMaterialEdit",
    //     component: RawMaterialEdit
    // },
    {
        path: "/inventory/formulaPlan",
        name: "formulaPlanList",
        component: FormulaPlanList
    },
    {
        path: "/inventory/formulaPlan/edit",
        name: "formulaPlanEdit",
        component: FormulaPlanEdit
    },
    {
        path: "/inventory/formulaPlanDetails/edit",
        name: "formulaPlanDetailsEdit",
        component: FormulaPlanDetailsEdit
    },

    //prd plan
    {
        path: "/prd/downtimePlan",
        name: "downtimePlanList",
        component: DowntimePlanList
    },
    {
        path: "/prd/downtimePlan/edit",
        name: "downtimePlanEdit",
        component: DowntimePlanEdit
    },
    {
        path: "/prd/monthPlan",
        name: "monthPlanList",
        component: MonthPlanList
    },
    {
        path: "/prd/monthPlan/edit",
        name: "monthPlanEdit",
        component: MonthPlanEdit
    },
    {
        path: "/prd/shiftPlan",
        name: "shiftPlanList",
        component: ShiftPlanList
    },
    {
        path: "/prd/shiftPlan/edit",
        name: "shiftPlanEdit",
        component: ShiftPlanEdit
    },
    {
        path: "/prd/matRequireMonthPlan",
        name: "matRequireMonthPlanList",
        component: MatRequireMonthPlanList
    },
    {
        path: "/prd/matRequireMonthPlan/edit",
        name: "matRequireMonthPlanEdit",
        component: MatRequireMonthPlanEdit
    },

    //prd result
    {
        path: "/prd/pelletizingEnergyCost",
        name: "pelletizingEnergyCostList",
        component: PelletizingEnergyCostList
    },
    {
        path: "/prd/pelletizingEquipPara",
        name: "pelletizingEquipParaList",
        component: PelletizingEquipParaList
    },
    {
        path: "/prd/pelletizingMaterialCost",
        name: "pelletizingMaterialCostList",
        component: PelletizingMaterialCostList
    },
    {
        path: "/prd/pelletizingProductInfo",
        name: "pelletizingProductInfoList",
        component: PelletizingProductInfoList
    },
    {
        path: "/prd/pelletizingProductionResult",
        name: "pelletizingProductionResultList",
        component: PelletizingProductionResultList
    },
    {
        path: "/prd/pelletizingProductQuality",
        name: "pelletizingProductQualityList",
        component: PelletizingProductQualityList
    },
    {
        path: "/prd/pelletizingProductionQuality",
        name: "pelletizingProductionQualityList",
        component: PelletizingProductionQualityList
    },

    {
        path: "/prd/smeltingProductionResult",
        name: "smeltingProductionResultList",
        component: SmeltingProductionResultList
    },
    {
        path: "/prd/smeltingMaterialCost",
        name: "smeltingMaterialCostList",
        component: SmeltingMaterialCostList
    },
    {
        path: "/prd/smeltingEnergyCost",
        name: "smeltingEnergyCostList",
        component: SmeltingEnergyCostList
    },
    {
        path: "/prd/smeltingProductInfo",
        name: "smeltingProductInfoList",
        component: SmeltingProductInfoList
    },
    {
        path: "/prd/smeltingProductQuality",
        name: "smeltingProductQualityList",
        component: SmeltingProductQualityList
    },
    {
        path: "/prd/smeltingEquipPara",
        name: "smeltingEquipParaList",
        component: SmeltingEquipParaList
    },
    {
        path: "/prd/smeltingMaterialPercentRecord",
        name: "smeltingMaterialPercentRecordList",
        component: SmeltingMaterialPercentRecordList
    },
    {
        path: "/prd/smeltingMaterialPercentRecord/edit",
        name: "smeltingMaterialPercentRecordEdit",
        component: SmeltingMaterialPercentRecordEidt
    },
    {
        path: "/prd/smeltingProductionQuality",
        name: "smeltingProductionQualityList",
        component: SmeltingProductionQualityList
    },

    //report
    {
        path: "/prd/dayEnergyCost",
        name: "dayEnergyCostList",
        component: DayEnergyCostList
    },
    {
        path: "/prd/dayEquipPara",
        name: "dayEquipParaList",
        component: DayEquipParaList
    },
    {
        path: "/prd/dayMaterialCost",
        name: "dayMaterialCostList",
        component: DayMaterialCostList
    },
    {
        path: "/prd/dayPelletizingProductInfo",
        name: "dayPelletizingProductInfoList",
        component: DayPelletizingProductInfoList
    },
    {
        path: "/prd/dayPelletizingProductQuality",
        name: "dayPelletizingProductQualityList",
        component: DayPelletizingProductQualityList
    },
    {
        path: "/prd/dayPelletizingProductionQuality",
        name: "dayPelletizingProductionQualityList",
        component: DayPelletizingProductionQualityList
    },
    {
        path: "/prd/daySmeltingProductInfo",
        name: "daySmeltingProductInfoList",
        component: DaySmeltingProductInfoList
    },
    {
        path: "/prd/daySmeltingProductQuality",
        name: "daySmeltingProductQualityList",
        component: DaySmeltingProductQualityList
    },
    {
        path: "/prd/daySmeltingProductionQuality",
        name: "daySmeltingProductionQualityList",
        component: DaySmeltingProductionQualityList
    },
    {
        path: "/prd/monthEnergyCost",
        name: "monthEnergyCostList",
        component: MonthEnergyCostList
    },
    {
        path: "/prd/monthEquipPara",
        name: "monthEquipParaList",
        component: MonthEquipParaList
    },
    {
        path: "/prd/monthMaterialCost",
        name: "monthMaterialCostList",
        component: MonthMaterialCostList
    },
    {
        path: "/prd/monthPelletizingProductInfo",
        name: "monthPelletizingProductInfoList",
        component: MonthPelletizingProductInfoList
    },
    {
        path: "/prd/monthPelletizingProductQuality",
        name: "monthPelletizingProductQualityList",
        component: MonthPelletizingProductQualityList
    },
    {
        path: "/prd/monthPelletizingProductionQuality",
        name: "monthPelletizingProductionQualityList",
        component: MonthPelletizingProductionQualityList
    },
    {
        path: "/prd/monthSmeltingProductInfo",
        name: "monthSmeltingProductInfoList",
        component: MonthSmeltingProductInfoList
    },
    {
        path: "/prd/monthSmeltingProductQuality",
        name: "monthSmeltingProductQualityList",
        component: MonthSmeltingProductQualityList
    },
    {
        path: "/prd/monthSmeltingProductionQuality",
        name: "monthSmeltingProductionQualityList",
        component: MonthSmeltingProductionQualityList
    },

    //quality
    {
        path: "/prd/qualitySpecification",
        name: "qualitySpecificationList",
        component: QualitySpecificationList
    },
    {
        path: "/prd/qualitySpecification/edit",
        name: "qualitySpecificationEdit",
        component: QualitySpecificationEdit
    },
    {
        path: "/prd/qualityItem",
        name: "qualityItemList",
        component: QualityItemList
    },
    {
        path: "/prd/qualityItem/edit",
        name: "qualityItemEdit",
        component: QualityItemEdit
    },
    {
        path: "/prd/qualityItem/add",
        name: "qualityItemAdd",
        component: QualityItemAdd
    },
    {
        path: "/prd/qualityItemDetails",
        name: "qualityItemDetailsList",
        component: QualityItemDetailsList
    },
    {
        path: "/prd/qualityItemDetails/edit",
        name: "qualityItemDetailsEdit",
        component: QualityItemDetailsEdit
    },
    {
        path: "/prd/furnaceTemperature",
        name: "furnaceTemperatureList",
        component: FurnaceTemperatureList
    },
    {
        path: "/prd/furnaceTemperature/edit",
        name: "furnaceTemperatureEdit",
        component: FurnaceTemperatureEdit
    },
    {
        path: "/prd/selfTestPelletizing",
        name: "selfTestPelletizingList",
        component: SelfTestPelletizingList
    },
    {
        path: "/prd/selfTestPelletizing/edit",
        name: "selfTestPelletizingEdit",
        component: SelfTestPelletizingEdit
    },
    {
        path: "/prd/selfTestPelletizingGri",
        name: "selfTestPelletizingGriList",
        component: SelfTestPelletizingGriList
    },
    {
        path: "/prd/selfTestPelletizingPel",
        name: "selfTestPelletizingPelList",
        component: SelfTestPelletizingPelList
    },
    {
        path: "/prd/selfTestPelletizingPel/edit",
        name: "selfTestPelletizingPelEdit",
        component: SelfTestPelletizingPelEdit
    },
    {
        path: "/prd/selfTestPelletizingGri/edit",
        name: "selfTestPelletizingGriEdit",
        component: SelfTestPelletizingGriEdit
    },
    {
        path: "/prd/selfTestPelletizingCal",
        name: "selfTestPelletizingCalList",
        component: SelfTestPelletizingCalList
    },
    {
        path: "/prd/selfTestPelletizingCal/edit",
        name: "selfTestPelletizingCalEdit",
        component: SelfTestPelletizingCalEdit
    },
    // {
    //     path: "/prd/selfTestPelletizingReport",
    //     name: "selfTestPelletizingReportList",
    //     component: SelftestPelletizingReportList
    // },
    {
        path: "/prd/qualityPlan",
        name: "qualityPlanList",
        component: QualityPlanList
    },
    {
        path: "/prd/qualitySamplePlan",
        name: "qualitySamplePlanList",
        component: QualitySamplePlanList
    },
    {
        path: "/prd/qualitySamplePlan/edit",
        name: "qualitySamplePlanEdit",
        component: QualitySamplePlanEdit
    },
    {
        path: "/prd/qualityData",
        name: "qualityDataList",
        component: QualityDataList
    },
    {
        path: "/prd/qualitySampleReceive",
        name: "qualitySampleReceiveList",
        component: QualitySampleReceiveList
    },
    {
        path: "/prd/qualityCheck",
        name: "qualityCheckList",
        component: QualityCheckList
    },
    {
        path: "/prd/qualityReview",
        name: "qualityReviewList",
        component: QualityReviewList
    },
    {
        path: "/prd/qualityDataCheck",
        name: "qualityDataCheckList",
        component: QualityDataCheckList
    },
    {
        path: "/prd/qualityResult",
        name: "qualityResultList",
        component: QualityResultList
    },
    {
        path: "/prd/qualityResult/display",
        name: "qualityResultDisplay",
        component: QualityResultDisplay
    },
    {
        path: "/prd/slagMeltingPoint",
        name: "slagMeltingPoint",
        component: SlagMeltingPointList
    },


    //prd record
    {

        path: "/prd/ceramicFilterParaRecord",
        name: "ceramicFilterParaList",
        component: CeramicFilterParaRecordList
    },
    {
        path: "/prd/ceramicFilterParaEdit",
        name: "ceramicFilterParaEdit",
        component: CeramicFilterParaEdit
    },
    {
        path: "/prd/smeltingPreheatingKilnPara",
        name: "smeltingPreheatingKilnParaList",
        component: SmeltingPreheatingKilnParaRecord
    },
    {
        path: "/prd/smeltingPreheatingKilnPara/edit",
        name: "smeltingPreheatingKilnParaEdit",
        component: SmeltingPreheatingKilnParaEdit
    },
    {
        path: "/prd/smeltingFurnaceMeasure",
        name: "smeltingFurnaceMeasureList",
        component: SmeltingFurnaceMeasureList
    },
    {
        path: "/prd/smeltingFurnaceMeasureEdit",
        name: "smeltingFurnaceMeasureEdit",
        component: SmeltingFurnaceMeasureEdit
    },
    {
        path: "/prd/coolingWaterPara",
        name: "coolingWaterParaList",
        component: CoolingWaterParaList
    },
    {
        path: "/prd/coolingWaterParaEdit",
        name: "coolingWaterParaEdit",
        component: CoolingWaterParaEdit
    },
    {
        path: "/prd/electrodePastePara",
        name: "electrodePasteParaList",
        component: ElectrodePasteParaList
    },
    {
        path: "/prd/electrodePasteParaEdit",
        name: "electrodePasteParaEdit",
        component: ElectrodePasteParaEdit
    },
    {
        path: "/prd/thickenerPumpPara",
        name: "thickenerPumpParaList",
        component: ThickenerPumpParaList
    },
    {
        path: "/prd/thickenerPumpPara/edit",
        name: "thickenerPumpParaEdit",
        component: ThickenerPumpParaEdit
    },
    {
        path: "/prd/smeltingPreheatingKilnStop",
        name: "smeltingPreheatingKilnStopList",
        component: SmeltingPreheatingKilnStopList
    },
    {
        path: "/prd/smeltingPreheatingKilnStopEdit",
        name: "smeltingPreheatingKilnStopEdit",
        component: SmeltingPreheatingKilnStopEdit
    },
    {
        path: "/prd/pressureDropWeightChange",
        name: "pressureDropWeightChangeList",
        component: PressureDropWeightChangeList
    },
    {
        path: "/prd/pressureDropWeightChange/edit",
        name: "pressureDropWeightChangeEdit",
        component: PressureDropWeightChangeEdit
    },
    {
        path: "/prd/releasedElectrodePara",
        name: "releasedElectrodeParaList",
        component: ReleasedElectrodeParaList
    },
    {
        path: "/prd/releasedElectrodePara/edit",
        name: "releasedElectrodeParaEdit",
        component: ReleasedElectrodeParaEdit
    },
    {
        path: "/prd/electrodeDischargePlan",
        name: "electrodeDischargePlanList",
        component: ElectrodeDischargePlanList
    },
    {
        path: "/prd/electrodeDischargePlan/edit",
        name: "electrodeDischargePlanEdit",
        component: ElectrodeDischargePlanEdit
    },
    {
        path: "/prd/gasCabinetPara",
        name: "gasCabinetParaList",
        component: GasCabinetParaList
    },
    {
        path: "/prd/gasCabinetPara/edit",
        name: "gasCabinetParaEdit",
        component: GasCabinetParaEdit
    },
    {
        path: "/prd/gasFlowPara",
        name: "gasFlowParaList",
        component: GasFlowParaList
    },
    {
        path: "/prd/gasFlowPara/edit",
        name: "gasFlowParaEdit",
        component: GasFlowParaEdit
    },
    {
        path: "/prd/substationOperationPara",
        name: "substationOperationParaList",
        component: SubstationOperationParaList
    },
    {
        path: "/prd/substationOperationPara/edit",
        name: "substationOperationParaEdit",
        component: SubstationOperationParaEdit
    },
    {
        path: "/prd/furnacePowerFailure",
        name: "furnacePowerFailureList",
        component: FurnacePowerFailureList
    },
    {
        path: "/prd/furnacePowerFailureEdit",
        name: "furnacePowerFailureEdit",
        component: FurnacePowerFailureEdit
    },
    {
        path: "/prd/slagIronPara",
        name: "slagIronParaList",
        component: SlagIronParaList
    },
    {
        path: "/prd/slagIronPara/edit",
        name: "slagIronParaEdit",
        component: SlagIronParaEdit
    },
    {
        path: "/prd/electrodeResistance",
        name: "electrodeResistanceList",
        component: ElectrodeResistanceList
    },
    {
        path: "/prd/electrodeResistance/edit",
        name: "electrodeResistanceEdit",
        component: ElectrodeResistanceEdit
    },
    {
        path: "/prd/drillDepth",
        name: "drillDepthList",
        component: DrillDepthList
    },
    {
        path: "/prd/drillDepth/edit",
        name: "drillDepthEdit",
        component: DrillDepthEdit
    },
    {
        path: "/prd/pelletFeeding",
        name: "pelletFeedingList",
        component: PelletFeedingList
    },
    {
        path: "/prd/pelletFeeding/edit",
        name: "pelletFeedingEdit",
        component: PelletFeedingEdit
    },
    //luanwf shiftHandOver
    {
        path: "/prd/shiftHandOver",
        name: "shiftHandOverList",
        component: ShiftHandOverList
    },
    {
        path: "/prd/shiftHandOver/edit",
        name: "shiftHandOverEdit",
        component: ShiftHandOverEdit
    },

    //luanwf productionInform
    {
        path: "/prd/productionInform",
        name: "productionInformList",
        component: ProductionInformList
    },{
        path: "/prd/productionInform/edit",
        name: "productionInformEdit",
        component: ProductionInformEdit
    },{
        path: "/prd/productionInform/display",
        name: "productionInformDisplay",
        component: ProductionInformDisplay
    },
]
